import React, { useState, useEffect } from 'react';
import logoLight from '../../assets/brand/Logo_DUIT_fondo claro.png';
import logoDark from '../../assets/brand/Logo_DUIT_fondo oscuro.png';

const Logo = ({ className = '', width = 120, height = 'auto' }) => {
  const [isDark, setIsDark] = useState(false);

  useEffect(() => {
    const checkTheme = () => {
      const theme = document.documentElement.getAttribute('data-theme');
      const systemDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
      
      setIsDark(theme === 'dark' || (!theme && systemDark));
    };

    // Check initial theme
    checkTheme();

    // Listen for theme changes
    const observer = new MutationObserver(checkTheme);
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['data-theme']
    });

    // Listen for system theme changes
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    mediaQuery.addEventListener('change', checkTheme);

    return () => {
      observer.disconnect();
      mediaQuery.removeEventListener('change', checkTheme);
    };
  }, []);

  const logoSrc = isDark ? logoDark : logoLight;

  return (
    <img 
      src={logoSrc}
      alt="Duit.tech" 
      className={className}
      style={{ width, height }}
    />
  );
};

export default Logo;
